import React, { Component, PropTypes } from "react"
import { Table, Row,message } from "antd"
import editAbleIcon from "app/styles/images/sp/edit.svg"
import deleteIcon from "app/styles/images/sp/delete.svg"
import { observer, inject } from "mobx-react"
import { withRouter } from 'react-router-dom'
import queryString from "query-string"

@inject('auth') @observer
class Index extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      showEditModal: false,
      editedHistory: [],
      name: "",
    }

    this.columns = []
  }

  componentWillReceiveProps(nextProps) {
    const { location } = this.props
    const { location: nextLocation } = nextProps

    if (nextLocation.search !== location.search) {
      if (nextLocation.search) {
        this.loadLimitedData(queryString.parse(nextLocation.search))
      } else {
        this.loadAllData()
      }
    }
  }

  componentDidMount() {
    let { location } = this.props
    if (location.search) {
      this.loadLimitedData(queryString.parse(location.search))
    } else {
      this.loadAllData()
    }
  }

  loadAllData() {
    const { store: { list } } = this.props
    list.getTableData()
      .then(
        res => {
          list.updateTableData(res)
          list.initPageIndex()
        }
      )
  }

  loadLimitedData(queryObj) {
    this.props.store.list.filterData(queryObj)
  }

  openDetail = (record) => {
    const { match, history } = this.props
    history.push(`${match.url}/${record.id}`)
  }
  deleteDataFun= (record) => {
    const { store: { list } } = this.props
    list.deleteDatalink(record.id)
    .then(result => {
      message.success("删除成功")
      let { location } = this.props
      if (location.search) {
        this.loadLimitedData(queryString.parse(location.search))
      } else {
        this.loadAllData()
      }
    }, error => {
      message.error(error.message)
    })
  }
  onPaginChange = selectedPageNumber => {
    let {
      store: {
        list
      },
    } = this.props

    list.changePagin(selectedPageNumber)

    document.getElementById("contentTop").scrollIntoView(true)
  }

  onSelectChange = (selectedRowKeys, selectedRows) => {
    this.props.store.selectedData = selectedRows
    this.props.store.selectedRowKeys = selectedRowKeys
  }

  render() {
    let {
      store: {
        list: {
          tableData,
          totalCount,
          queryMap,
          currentPageIndex,
        },
       
      },
    } = this.props
    this.columns = [
      {
        title: (
          <div className="ta-l">缺失类型</div>
        ),
        dataIndex: "keyword",
        render: (text) => {
          return (
            <div className="ta-l">
              {text || '-'}
            </div>
          )
        }
      },
      {
        title: (
          <div className="ta-l">缺失名称</div>
        ),
        dataIndex: "name",
        render: (text) => {
          return (
            <div className='ta-l'>
              {text || '-'}
            </div>
          )
        }
      },
      {
        title: (
          <div className="ta-l">缺失STS位点</div>
        ),
        dataIndex: "stsPoint",
        render: (text, record) => {
          return (
            <div className="ta-l">{text || '-'}</div>
          )
        }
      },{
        title: (
          <div className="ta-l">Y染色体位置</div>
        ),
        dataIndex: "yPosition",
        render: (text, record) => {
          return (
            <div className="ta-l">{text || '-'}</div>
          )
        }
      },
       
      {
        title: (
          <div className="ta-l">结果</div>
        ),
        dataIndex: "result",
        render: (text, record) => {
          return (
            <div className="ta-l">{text || '-'}</div>
          )
        }
      },
      {
        title: (
          <div className="ta-l">结论</div>
        ),
        dataIndex: "tips",
        render: (text, record) => {
          return (
            <div className="ta-l">{text || '-'}</div>
          )
        }
      },
      {
        title: (
          <div className="ta-l">大小</div>
        ),
        dataIndex: "size",
        render: text => {
          return (
            <div className="ta-l">{text}</div>
          )
        }
      },
      {
        title: (
          <div className="ta-c">操作</div>
        ),
        
        dataIndex: "operator",
        render: (text, record) => {
          return (
            <Row className="table-oprator" type="flex" justify="space-between" align="middle">
            
              <img
                title="编辑"
                src={editAbleIcon}
                alt=""
                onClick={() => this.openDetail(record)}
                style={{ cursor: 'pointer',marginRight:'10px' }}
              />
       
              <img
                title="删除"
                src={deleteIcon}
                alt=""
                onClick={() => this.deleteDataFun(record)}
                style={{ cursor: 'pointer' }}
              />
            </Row>
          )
        }
      }
    ]
    return (
      <div>
        <div className='wrapper-box-azf'>
          <Table
            className="pgd-datamanage-table"
            columns={this.columns}
            rowKey={record => record.id}
            dataSource={tableData.slice()}
            pagination={{
              pageSize: queryMap.limit,
              onChange: this.onPaginChange,
              defaultCurrent: 1,
              current: currentPageIndex,
              total: totalCount,
            }}
          >
          </Table>
        </div>
      </div>
    )
  }
}
export default withRouter(Index)



// WEBPACK FOOTER //
// ./src/app/pages/research/azf/data_manage/containers/DataTable.js